export class ApiError extends Error {
    status;
    code;
    details;
    constructor(status, message, code, details) {
        super(message);
        this.name = 'ApiError';
        this.status = status;
        this.code = code;
        this.details = details;
    }
}
let baseUrl = 'http://localhost:3000/api/v1';
let getToken = () => null;
let setToken = () => { };
let onAuthFailure = () => { };
export function configureApi(opts) {
    if (opts.baseUrl)
        baseUrl = opts.baseUrl;
    if (opts.getToken)
        getToken = opts.getToken;
    if (opts.setToken)
        setToken = opts.setToken;
    if (opts.onAuthFailure)
        onAuthFailure = opts.onAuthFailure;
}
let refreshPromise = null;
async function attemptRefresh() {
    if (refreshPromise)
        return refreshPromise;
    refreshPromise = (async () => {
        try {
            const res = await fetch(`${baseUrl}/auth/refresh`, {
                method: 'POST',
                credentials: 'include',
                headers: { Accept: 'application/json' },
            });
            if (!res.ok)
                return null;
            const payload = (await res.json());
            if (!payload.success || !payload.data?.token)
                return null;
            setToken(payload.data.token);
            return payload.data.token;
        }
        catch {
            return null;
        }
        finally {
            refreshPromise = null;
        }
    })();
    return refreshPromise;
}
async function rawRequest(path, opts) {
    const { method = 'GET', body, signal, skipAuthRefresh } = opts;
    const token = opts.token === undefined ? getToken() : opts.token;
    const headers = { Accept: 'application/json' };
    if (body !== undefined)
        headers['Content-Type'] = 'application/json';
    if (token)
        headers['Authorization'] = `Bearer ${token}`;
    if (opts.headers)
        Object.assign(headers, opts.headers);
    let res;
    try {
        res = await fetch(`${baseUrl}${path}`, {
            method,
            headers,
            credentials: 'include',
            body: body !== undefined ? JSON.stringify(body) : undefined,
            signal,
        });
    }
    catch (err) {
        throw new ApiError(0, err instanceof Error ? err.message : 'Network error');
    }
    if (res.status === 401 && token && !skipAuthRefresh) {
        const newToken = await attemptRefresh();
        if (newToken) {
            return rawRequest(path, { ...opts, token: newToken, skipAuthRefresh: true });
        }
        onAuthFailure();
    }
    let payload = null;
    try {
        payload = (await res.json());
    }
    catch {
        throw new ApiError(res.status, res.statusText || 'Request failed');
    }
    if (!res.ok || !payload || payload.success === false) {
        const err = payload && payload.success === false ? payload : null;
        throw new ApiError(res.status, err?.error ?? res.statusText ?? 'Request failed', err?.code, err?.details);
    }
    return { res, payload };
}
export async function apiRequest(path, opts = {}) {
    const { payload } = await rawRequest(path, opts);
    if (payload && 'data' in payload && payload.data !== undefined) {
        return payload.data;
    }
    const { success: _success, ...rest } = payload ?? { success: true };
    return rest;
}
/**
 * Like `apiRequest`, but also surfaces sibling envelope fields under `meta`
 * (e.g. `{ success, data, meta: { dataThrough } }`) — for endpoints whose
 * response carries more than just `data`.
 */
export async function apiRequestEnvelope(path, opts = {}) {
    const { payload } = await rawRequest(path, opts);
    const data = (payload && 'data' in payload ? payload.data : undefined);
    const meta = (payload && 'meta' in payload ? payload.meta : undefined);
    return { data, meta };
}
//# sourceMappingURL=client.js.map